var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9H7V10H4V9Z",
    fill: "#1C1E21",
    stroke: "#1C1E21",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11H9V12H4V11Z",
    fill: "#1C1E21",
    stroke: "#1C1E21",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H3C2.73486 2.00026 2.48066 2.10571 2.29319 2.29319C2.10571 2.48066 2.00026 2.73486 2 3V13C2.00026 13.2651 2.10571 13.5193 2.29319 13.7068C2.48066 13.8943 2.73486 13.9997 3 14H13C13.2651 13.9997 13.5193 13.8943 13.7068 13.7068C13.8943 13.5193 13.9997 13.2651 14 13V3C13.9997 2.73486 13.8943 2.48066 13.7068 2.29319C13.5193 2.10571 13.2651 2.00026 13 2ZM9 3V5H7V3H9ZM3 13V3H6V6H10V3H13L13.0005 13H3Z",
    fill: "#1C1E21",
    stroke: "#1C1E21",
    strokeWidth: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDetails);
export default __webpack_public_path__ + "static/media/productDetails.545e40273f4f4e1f6be7b00d08432d6f.svg";
export { ForwardRef as ReactComponent };